var _ = require('lodash');
(function Module() {
	'use strict';

    mySynch.filter('demoUserFilter', ['$filter','MySynchFactory', function($filter,MSF) {
        return function (input, demoValue, override=false) {
           
             var isDemoUser = _.get(MSF.getActiveUser(),'IsDemoUser',false);

             if(!override && isDemoUser){
                return demoValue;
             }else{
                return input;
             }
           
        };
    }]);

})();